import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingCountOfPartnersForInitPlans = createSelector(
  [selectLandingState],
  ({ countOfPartnersForInitPlans }) => countOfPartnersForInitPlans
)
